import createPendoTag from './pendo';
import { ITectonSuccessResponse } from 'q2-tecton-common/lib/utility/message-bus';
import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';
import { PendoInfo, PendoOptions } from '../types/pendo';
import { interval } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { TectonWindow } from '@/types';

type PendoWindow = TectonWindow & {
    pendo: {
        updateOptions(options: PendoOptions): void;
    };
};

export default function setupAnalytics(
    messageBus: SDKMessageBus,
    moduleInstanceId: string,
    capabilities: Set<string>
): void {
    // don't setup analytics for the sdk living in ngam
    if (moduleInstanceId !== 'legacy' && capabilities.has('getPendoInfo')) {
        messageBus
            .sendRequest<PendoInfo>('getPendoInfo', Maybe.nothing<string>())
            .then(pendoInfoResponse => {
                const pendoWindow = window as PendoWindow;
                const { isPendo, pendoOptions } = (pendoInfoResponse as ITectonSuccessResponse<
                    PendoInfo
                >).value;
                if (isPendo) {
                    (window as PendoWindow).Tecton.pendo = {
                        apiKey: pendoOptions.apiKey,
                        additionalApiKeys: pendoOptions.additionalApiKeys
                    };
                    createPendoTag();

                    const whenPendoReady = interval(200)
                        .pipe(
                            filter(() => !!pendoWindow.pendo),
                            take(1)
                        )
                        .toPromise();

                    whenPendoReady.then(() => {
                        isPendo &&
                            pendoWindow.pendo.updateOptions({
                                visitor: { ...pendoOptions.visitor }
                            });
                    });
                }
            });
    }
}
